import config from 'config'
import React, { Fragment } from 'react'
import { connect, useSelector } from 'react-redux'
import { withTranslation } from 'react-i18next'
import history from 'srcReact/helpers/history'
import { commonActions } from 'srcReact/components'

const LowerThanFreeSeats = (props) => {
  const { t, isBillable } = props
  const {
    common: { isNative },
  } = useSelector((state) => state)

  const handlePricingClick = () => {
    //nativeapp
    if (isNative) {
      window.location = config.webUrl + `/0/pricing`
      return
    }
    history.push('/0/pricing')
  }

  const handleClosePopin = () => {
    const { closePopin } = props

    closePopin()
  }

  return (
    <Fragment>
      <h2 className='popin-content--title'>{t('billing.popin.lowerThanFreeSeats.title')}</h2>
      <p className='popin-content--text'>
        {isBillable ? t('billing.popin.lowerThanFreeSeats.ownerText') : t('billing.popin.lowerThanFreeSeats.text')}
      </p>
      <div className='popin-content--image'>
        <img src={`${config.assetUrl}/images/urban-design.svg`} alt='urban-design' />
      </div>
      <div className='popin-content--controllers with-link'>
        {isBillable ? (
          <button type='button' className='button is-primary' onClick={() => handlePricingClick()}>
            {t('billing.popin.lowerThanFreeSeats.ownerBtnText')}
          </button>
        ) : (
          <Fragment>
            <button type='button' className='button is-primary' onClick={() => handleClosePopin()}>
              {t('billing.popin.lowerThanFreeSeats.btnPrimary')}
            </button>
            <a onClick={() => handlePricingClick()} title={t('billing.pricing.seePricing')} className='controller-link'>
              {t('billing.pricing.seePricing')}
            </a>
          </Fragment>
        )}
      </div>
    </Fragment>
  )
}

const actionCreators = {
  closePopin: commonActions.closePopin,
}

const ExtendedComponent = withTranslation('common')(LowerThanFreeSeats)
const connectedLowerThanFreeSeats = connect(null, actionCreators)(ExtendedComponent)

export { connectedLowerThanFreeSeats as LowerThanFreeSeats }
